import { getCanvasBasicsSteps } from "./canvasBasics";
import { getAiChatModesSteps } from "./aiChatModes";
import { getSaveManageSteps } from "./saveManage";
import { getAdvancedFeaturesSteps } from "./advancedFeatures";

export {
  getCanvasBasicsSteps,
  getAiChatModesSteps,
  getSaveManageSteps,
  getAdvancedFeaturesSteps,
};

/**
 * Returns all tour definitions in display order.
 * @param {{ t: (key: string, opts?: object) => string }} deps
 */
export function getAllTours({ t }) {
  return [
    getCanvasBasicsSteps({ t }),
    getAiChatModesSteps({ t }),
    getSaveManageSteps({ t }),
    getAdvancedFeaturesSteps({ t }),
  ];
}
